import fgInput from './components/UIComponents/Inputs/formGroupInput.vue'
import DropDown from './components/UIComponents/Dropdown.vue'
import Checkbox from './components/UIComponents/Inputs/Checkbox.vue'
import Radio from './components/UIComponents/Inputs/Radio.vue'
import PPagination from 'src/components/UIComponents/Pagination.vue'
import PSearch from 'src/components/UIComponents/Inputs/Search.vue'
import ActionsTableLayout from 'src/components/Layout/ActionsTableLayout'
import RouterButton from 'src/components/Layout/RouterButton'
import ActionButtonClickStateless from 'src/components/Layout/ActionButtonClickStateless'
import ActionButtonClick from 'src/components/Layout/ActionButtonClick'
import StatelessFactory from 'src/components/StatelessFactory'
import RadioColors from 'src/components/Trg/RadioColors/RadioColors'

import { isFunction } from './services/Helper'

const elementUi = require('element-ui')
const elementUiComponents = []
for (let el in elementUi) {
  if (isFunction(elementUi[el])) {
    continue
  }
  if (!elementUi[el].hasOwnProperty('name')) {
    continue
  }
  elementUiComponents.push(
    {
      name: elementUi[el].name,
      component: elementUi[el]
    }
  )
}
/**
 * You can register global components here and use them as a plugin in your main Vue instance
 * Ideally, only small components that are re-used many times across your application should be registered here.
 * For plugins and bigger components local registration is preferable because it will allow you to do code splitting easier :)
 */

const GlobalComponents = {
  install (Vue) {
    for (let component of elementUiComponents) {
      Vue.component(component.name, component.component)
    }
    Vue.component(StatelessFactory.name, StatelessFactory)
    Vue.component(RadioColors.name, RadioColors)
    Vue.component(ActionsTableLayout.name, ActionsTableLayout)
    Vue.component(RouterButton.name, RouterButton)

    Vue.component(ActionButtonClickStateless.name, ActionButtonClickStateless)
    Vue.component(ActionButtonClick.name, ActionButtonClick)

    Vue.component(fgInput.name, fgInput)
    Vue.component(DropDown.name, DropDown)
    Vue.component(Checkbox.name, Checkbox)
    Vue.component(Radio.name, Radio)
    Vue.component(Radio.name, Radio)
    Vue.component(PPagination.name, PPagination)
    Vue.component(PSearch.name, PSearch)
  }
}

export default GlobalComponents



// WEBPACK FOOTER //
// ./src/globalComponents.js